import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Button from '@hotmart/space-lib/dist/components/button'
import Icon from '@hotmart/space-lib/dist/components/icon'
import i18n from 'src/i18n'
import { useUserProfile } from 'src/components/globalUserProfile'
import { Title } from './header.styles'

const Header = () => {
  const { onClose } = useUserProfile()

  return (
    <header className="_p-5">
      <div className="_d-flex _justify-content-between _align-items-center">
        <Title className="_text-gray-900 _mb-0">{i18n.t('profile.header.title')}</Title>

        <Button
          variation="tertiary"
          className="_p-1 _d-flex _border-0 _bg-transparent _text-gray-900 _ml-auto"
          onClick={onClose}
        >
          <span className="_sr-only">close</span>
          <Icon icon={faXmark} className="_w-5 _h-5" />
        </Button>
      </div>
    </header>
  )
}

export default Header
